import { style } from '@/styles/globals';
import { Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import 'moment/locale/vi';
import { useRouter } from 'next/router';
import React from 'react';
import FlexColCenter from '../FlexColCenter';

const Container = styled('div')(({ theme }) => ({
  paddingTop: theme.palette.xSmall,
  paddingBottom: theme.palette.xSmall,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#FFFFFF',
  backgroundColor: 'FFFFFF',
  position: 'sticky',
  top: 0,
  maxHeight: '48px',
  boxSizing: 'border-box',
  zIndex: 1000,
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
}));
const StyledIconButton = styled(Button)({
  position: 'absolute',
  left: 0,
});

interface MobileHeaderProps {
  title: string;
  subTitle?: string;
  isHideBackIcon?: boolean;
  onGoBack?: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  subTitle,
  onGoBack,
  isHideBackIcon,
}) => {
  const router = useRouter();
  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else if (router.asPath.includes('/pay-')) {
      router.push('/');
    } else {
      router.back();
    }
  };
  return (
    <Container>
      <StyledIconButton onClick={handleGoBack}>
        {!isHideBackIcon && (
          <img
            height="14px"
            alt="arrow-left"
            src="/images/arrow-left.png"
          />
        )}
      </StyledIconButton>
      <FlexColCenter sx={{ maxWidth: '70%' }}>
        <Stack sx={{ textAlign: 'center' }}>
          <Typography
            variant="title"
            fontWeight="500"
            color={(theme) => theme.palette.black1}
          >
            {title}
          </Typography>
          {subTitle && (
          <Typography
            variant="caption"
            fontWeight="500"
            color={style.color.black4}
          >
            {subTitle}
          </Typography>

          )}

        </Stack>
      </FlexColCenter>
    </Container>
  );
};

export default MobileHeader;
